import axios from 'axios'
import config from '@/config'
const webApi = config[process.env.NODE_ENV].nextbestApi
export default {
    async saveLog(params) {
        try {
            console.log(params)
            let rs = await axios({
                method: 'post',
                headers: { Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6InZpbGxhbWFya2V0Iiwic3RhdHVzIjoiQUNUSVZFIiwiY2xpZW50SWQiOiJkODExYTEyYS0xMjU2LTQ0NjQtYWY4Mi04YjQxODkyZGM3YTAiLCJjbGllbnRDb2RlIjoidmlsbGFtYXJrZXQiLCJpYXQiOjE2MzIyMzkyNDEsImV4cCI6MTcyNjkxMjA0MX0.7ehQR6L8p1eQebh36QdxH6SwaTYz4fYIgEONJZTVwMo` },
                url: `${webApi}/log/createlogByCam`,
                responseType: 'json',
                data: params
            })
            if (rs.status === 200) {
                return rs.data
            } else {
                return null
            }
        } catch (e) {
            console.log(e)
            return null
        }
    },
    async saveLogCustom(params) {
        try {
            // console.log(params)
            let rs = await axios({
                method: 'post',
                // headers: { Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6InNpenpsZXIiLCJzdGF0dXMiOiJBQ1RJVkUiLCJjbGllbnRJZCI6ImFhOWRjODc3LWU3ODEtNGM2MC1iYjRkLTUzYjVhNzFjMTM1MyIsImNsaWVudENvZGUiOiJzaXp6bGVyIiwiaWF0IjoxNjE0OTM3NTE2LCJleHAiOjE2NDY0OTUxMTZ9.tiM7mFynpzm3xTjRWBkoJvpO0P5f3_DpTXqGKQg0zfk` },
                url: `https://01emepd7xf.execute-api.ap-southeast-1.amazonaws.com/webhook/webhook/custom/villamarket`,
                responseType: 'json',
                data: params
            })
            if (rs.status === 200) {
                return rs.data
            } else {
                return null
            }
        } catch (e) {
            console.log(e)
            return null
        }
    }

}